<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="animatedGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#70d6ff">
          <animate
            attributeName="stop-color"
            values="#70d6ff;#fc70ff;#0064ff;#fc70ff;#70d6ff"
            dur="8s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="25%" stop-color="#fc70ff">
          <animate
            attributeName="stop-color"
            values="#fc70ff;#0064ff;#fc70ff;#70d6ff;#fc70ff"
            dur="8s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="50%" stop-color="#0064ff">
          <animate
            attributeName="stop-color"
            values="#0064ff;#fc70ff;#70d6ff;#fc70ff;#0064ff"
            dur="8s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="75%" stop-color="#fc70ff">
          <animate
            attributeName="stop-color"
            values="#fc70ff;#70d6ff;#fc70ff;#0064ff;#fc70ff"
            dur="8s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="100%" stop-color="#70d6ff">
          <animate
            attributeName="stop-color"
            values="#70d6ff;#fc70ff;#0064ff;#fc70ff;#70d6ff"
            dur="8s"
            repeatCount="indefinite" />
        </stop>
      </linearGradient>
    </defs>
    <path
      d="M13.4964 5.55468C13.4587 4.19584 12.9371 2.8951 12.0254 1.88675C11.1138 0.878393 9.87203 0.228699 8.52385 0.054684C7.01801 -0.154444 5.49064 0.241296 4.27581 1.15534C3.06098 2.06939 2.25759 3.42735 2.04135 4.93218C1.92607 5.87021 2.05279 6.82213 2.40943 7.69733C2.76608 8.57254 3.34079 9.3419 4.07885 9.93218L4.20385 10.0222C4.57141 10.3682 4.83542 10.8097 4.96635 11.2972L5.07385 12.9922V13.3372C5.08236 14.0417 5.36721 14.7147 5.86706 15.2113C6.36691 15.7079 7.04178 15.9883 7.74635 15.9922H7.77385C8.48525 15.9837 9.16488 15.6963 9.66655 15.1918C10.1682 14.6873 10.4518 14.0061 10.4564 13.2947V12.9922L10.5614 11.3097C10.7013 10.8081 10.9856 10.3586 11.3789 10.0172C12.0397 9.48223 12.5728 8.80644 12.9392 8.03915C13.3055 7.27186 13.4959 6.43244 13.4964 5.58218V5.55468ZM8.45635 13.3047C8.45065 13.4861 8.37571 13.6584 8.24693 13.7863C8.11814 13.9141 7.94528 13.9878 7.76385 13.9922C7.584 13.9903 7.41181 13.9191 7.28323 13.7933C7.15466 13.6675 7.07965 13.497 7.07385 13.3172V12.9547L7.04385 12.4922H8.49635L8.47135 12.8922L8.45635 13.3047ZM10.1064 8.47718L10.0839 8.49718C9.46114 9.03142 8.99176 9.72169 8.72385 10.4972H6.80635C6.52642 9.67776 6.02861 8.95006 5.36635 8.39218L5.11635 8.20468C4.70536 7.82987 4.39079 7.3615 4.1993 6.83927C4.00782 6.31703 3.94506 5.75633 4.01635 5.20468C4.15819 4.22345 4.68282 3.33831 5.47551 2.74286C6.26821 2.1474 7.26445 1.89008 8.24635 2.02718C9.12411 2.13642 9.93397 2.55567 10.5299 3.20934C11.1258 3.86301 11.4686 4.70809 11.4964 5.59218C11.4928 6.14457 11.3662 6.68922 11.1258 7.18654C10.8853 7.68386 10.5371 8.12135 10.1064 8.46718V8.47718Z"
      fill="url(#animatedGradient)" />
  </svg>
</template>

<script setup lang="ts">
// No props needed - animation is built into the SVG
</script>
